import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { useAuth } from "context/AuthContext";
import DetailModal from "../Clients/modals/DetailModal";
import { Toaster } from "react-hot-toast";
import ClientDetailCoach from "../Clients/Details/ClientDetailCoach";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ClassScheduleCard from "components/shared/ClassScheduleCard";
import { useMisClases } from "hooks/useMisClases";
import useSedeRefresh from "../../../hooks/useSedeRefresh";

function MisClases() {
  const { user } = useAuth();
  const {
    schedules,
    loading,
    clientModalOpen,
    selectedClient,
    handleAttendanceChange,
    handleViewClient,
    toggleClientModal,
    fetchBookings
  } = useMisClases(user?.id, user?.groups || []);

  // Escuchar cambios de sede y refrescar automáticamente
  useSedeRefresh(fetchBookings, [fetchBookings]);

  return (
    <LoadingOverlay loading={loading}>
      <div className="content">
        <Toaster position="top-right" />
        
        <DetailModal
          isOpen={clientModalOpen}
          toggle={toggleClientModal}
          title={
            selectedClient
              ? `Alumno: ${selectedClient.first_name} ${selectedClient.last_name}`
              : "Detalles del alumno"
          }
          content={
            <ClientDetailCoach
              client={selectedClient}
              onClose={() => toggleClientModal()}
            />
          }
          showPrimaryAction={false}
        />
        
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  {user?.groups?.includes('coach') 
                    ? `Hola, ${user.first_name} estas son tus clases del día de hoy!`
                    : `Clases del día de hoy - ${user?.groups?.includes('admin') ? 'Administrador' : 'Secretaria'}`
                  }
                </CardTitle>
              </CardHeader>
              <CardBody>
                {schedules.length === 0 ? (
                  <p>
                    {user?.groups?.includes('coach') 
                      ? 'No tienes clases programadas hoy.'
                      : 'No hay clases programadas hoy.'
                    }
                  </p>
                ) : (
                  schedules.map((schedule, index) => (
                    <ClassScheduleCard
                      key={index}
                      schedule={schedule}
                      onAttendanceChange={handleAttendanceChange}
                      onViewClient={handleViewClient}
                    />
                  ))
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </LoadingOverlay>
  );
}

export default MisClases;
